<template>
    <div
        v-if="show"
        class="message-box pro-message-box flex"
    >
        <subscription-switch />
        <div class="content">
            <h3>
                Your {{ licenseName }} license is active!
            </h3>
            <p>
                <slot v-if="'Lifetime' !== licenseName" name="box-text" />
                <template v-else>
                    Use this key to activate the license in your WordPress site:
                </template>
            </p>
            <license-key
                v-if="isBilling || 'lifetime' === license.type || license.free_seats > 0 "
                :license="license"
            />
            <manage-sites-section v-else />
        </div>
        <sites-counter
            :license="license"
        />
    </div>
</template>

<script>
import LicenseKey from './Tools/LicenseKey.vue';
import SitesCounter from './Tools/SitesCounter.vue';
import ManageSitesSection from './Tools/ManageSitesSection';
import SubscriptionSwitch from './Dashboard/SubscriptionSwitch';

import { mapState } from 'vuex';

export default {
    components: {
        LicenseKey,
        SitesCounter,
        ManageSitesSection,
        SubscriptionSwitch,
    },

    props: {
        license: {
            type: Object,
            default: () => {},
        },
        index: {
            type: String,
            default: '',
        },
        isBilling: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapState(['user', 'currentSubscription', 'UIState']),

        /**
         * @returns {string} License name.
         */
        licenseName() {
            return 'lifetime' === this.license.type ? 'Lifetime' : 'Pro';
        },

        /**
         * @returns {boolean} Whether to show the license box.
         */
        show() {
            return ! this.user.pro || this.currentSubscription?.id === this.license.subscription_id;
        },
    },
};
</script>
